import { render, staticRenderFns } from "./CopyMenuCategory.vue?vue&type=template&id=f469d8f8"
import script from "./CopyMenuCategory.vue?vue&type=script&lang=ts"
export * from "./CopyMenuCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports